<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['sided_agenda']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Podtytuł',
              modelPath: [this, 'form', 'subtitle'],
              multilingual: true,
              required: true
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'sided_agenda'],
              items: this.form.sided_agenda.map((item, i) => {
                return {
                  headerLabel: get(item, ['text_en']),
                  fields: [
                    new fields.Input({
                      label: 'Tekst',
                      modelPath: [this, 'form', 'sided_agenda', i, 'text'],
                      multilingual: true,
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
